export function setConfig(key, value) {
  const config = {
    [key]: value,
  };
  return {
    type: 'SET_CONFIG',
    config,
  };
}
export function setLayout(layout) {
  return {
    type: 'SET_LAYOUT',
    layout,
  };
}

export function setLogin(value) {
  return {
    type: 'SET_LOGIN',
    login: value,
  };
}



// WEBPACK FOOTER //
// ./src/actions/config.js